
<div>
  <mat-card *ngIf="!canChangePassword">
    <mat-card-header>
      <mat-card-title i18n="section header">Authentication</mat-card-title>
    </mat-card-header>
    <mat-card-content i18n>Using social login</mat-card-content>
  </mat-card>
  <mat-card *ngIf="canChangePassword">
    
    <form (ngSubmit)="changePassword()" [formGroup]="passwordForm">
    
      <mat-card-header>
        <mat-card-title i18n="section header">Change password</mat-card-title>
      </mat-card-header>
      
      <mat-card-content>
        <div>
          <mat-form-field [style.width.px]=300>
            <mat-label i18n>Old password</mat-label>
            <input matInput formControlName="oldPassword" required>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field [style.width.px]=300>
            <mat-label i18n>New password</mat-label>
            <input matInput formControlName="newPassword" required>
            <mat-error *ngIf="passwordForm.controls['newPassword'].errors?.['minlength']" i18n>Password must contain at least 12 characters</mat-error>
            <mat-error *ngIf="passwordForm.controls['newPassword'].errors?.['didnMatchRegex'] == 'containsDigit'" i18n>Password must contain a number</mat-error>
            <mat-error *ngIf="passwordForm.controls['newPassword'].errors?.['didnMatchRegex'] == 'containsUppercase'" i18n>Password must contain an upper case letter</mat-error>
            <mat-error *ngIf="passwordForm.controls['newPassword'].errors?.['didnMatchRegex'] == 'containsSpecialOrWhitespace'" i18n>Password must contain a special character or a space</mat-error>
            <mat-error *ngIf="passwordForm.controls['newPassword'].errors?.['didnMatchRegex'] == 'startOrEndsWithWhitespace'" i18n>Password must not contain a leading or trailing space</mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field [style.width.px]=300>
            <mat-label i18n="label for field to enter new password 2 times">Repeat new password</mat-label>
            <input matInput formControlName="repeatNewPassword" required>
          </mat-form-field>
        </div>
        
        <div>
          <mat-error *ngIf="passwordForm.errors?.['passwordsDontMatch'] && (passwordForm.touched || passwordForm.dirty)" i18n="error when old and new password are not equal">
            Passwords don't match
          </mat-error>
        </div>
        
      </mat-card-content>
    
      <mat-card-actions>
        <button mat-raised-button type="submit" color="accent" [disabled]="!passwordForm.valid" i18n="button label">Change password</button>
      </mat-card-actions>
      
    </form>
    
  </mat-card>
  
</div>